/* @flow */

import * as React from 'react';

import {getApiTypeFromGraphQLTypename} from 'nutshell-core/utils/get-api-type-from-graphql-typename';

import {LinkedEntity} from 'shells/linked-entity';

import type {EventFragmentSparse} from 'nutshell-graphql-types';

import {TimelineBanner} from './timeline-banner';

import './timeline-banner.module.css';

type Props = {|event: EventFragmentSparse|};

export function TimelineBannerIntelligenceDetailsAdded(props: Props) {
    const {event} = props;
    const {payload} = event;

    /**
     * We need to include this check, even though we are only passing an event
     * with a payload.__typename of 'Account' or 'Contact' because Apollo
     * doesn't generate a specific enough type when using a union type (like the
     * TimelineEventPayload). See this issue for more detail:
     * https://github.com/apollographql/apollo-tooling/issues/1223
     */
    if (payload.__typename !== 'Account' && payload.__typename !== 'Contact') {
        return null;
    }

    const getAction = (name: string, htmlUrl: string) => {
        const linkedEntity = (
            <strong>
                <LinkedEntity
                    type={getApiTypeFromGraphQLTypename(payload.__typename)}
                    useEntityColor={true}
                    shouldClientRoute={true}
                    name={name}
                    htmlUrl={htmlUrl}
                    allowWrap={true}
                    displayInline={true}
                    greenLeads={true}
                />
            </strong>
        );

        return (
            <span>
                added new details to&nbsp;
                {linkedEntity}&nbsp;with <strong>Nutshell Intelligence</strong>
            </span>
        );
    };

    const {name, htmlUrl} = payload;

    return (
        <TimelineBanner
            id={event.id}
            iconVariant='intelligence-details-added'
            timestamp={event.changeTime}
            actor={event.actor}
            action={getAction(name, htmlUrl)}
        />
    );
}
